import { 
    OBTENER_RESULTADOS,
    ERROR_OBTENER_RESULTADOS,
    PAGINA_ACTUAL,
    OBTENER_ID_RESULTADO_SELECCIONADO
 } from '../../types';

 export default (state, action) => {
    switch(action.type) {
        case OBTENER_RESULTADOS:
            return {
                ...state,
                resultados: action.payload
            }
        case ERROR_OBTENER_RESULTADOS:
            return {
                ...state,
                resultados: [],
                paginaActual: 1
            }
        case PAGINA_ACTUAL:
            return {
                ...state,
                paginaActual: action.payload
            }
        case OBTENER_ID_RESULTADO_SELECCIONADO:
            localStorage.removeItem("id");
            return {
                ...state,
                idSeleccionado: action.payload
            }
        default:
            return state;
    }
 }